import {
  Alert,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  TimePicker,
} from "antd";

import { locale } from "moment";
import { useContext, useEffect, useState } from "react";
import { getLocalViagens } from "../../../services/locais";
import { getMotoristas } from "../../../services/motoristas";
import { getPacientes } from "../../../services/pacientes";
import { getVeiculos } from "../../../services/veiculos";
import { FormItemInput, FormItemSelect } from "../../ant-wrapper/form-item";
import DetailLocalBox from "../../locais/detail-box";
import { PRIORIDADE_FIELDS } from "../../utils";
import { SITUACOES } from "../../../models/atendimentos";
import SkeletonContainer from "../../skeleton-container";
import { finalizarViagem } from "../../../services/viagens";
import { UserContext } from "../../../context";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

export default function ViagemForm({
  onFinish,
  setError,
  error,
  initialValues = {},
  loading = false,
  viewMode = false,
  disabledButtons = false,
}) {
  const [form] = Form.useForm();
  const isAprovable = () => {
    return initialValues.status === SITUACOES.LANCADO;
  };
  const onEdit = () => {
    setError();
  };
  const cardStyle = { borderColor: "white" };
  const [pacientes, setPacientes] = useState([]);
  const [localOrigem, setLocalOrigem] = useState();
  const [loadingFinalizar, setLoadingFinalizar] = useState(false);
  const [localDestino, setLocalDestino] = useState();
  const [motoristas, setMotoristas] = useState([]);
  const [loadingDados, setloadingDados] = useState(false);
  const [veiculos, setVeiculos] = useState([]);
  const [locais, setLocais] = useState([]);
  const [locaisDestino, setLocaisDestino] = useState([]);

  const user = useContext(UserContext);
  const onSearch = async (result) => {
    const pacientesData = await getPacientes(0, result);
    setPacientes(pacientesData.data);
  };
  const getData = async () => {
    setloadingDados(true);
    const pacientesData = await getPacientes(0, "");
    const motoristasData = await getMotoristas(0, "");
    const veiculoData = await getVeiculos(0, "");
    const localData = await getLocalViagens(0, "");
    setPacientes(pacientesData.data);
    setMotoristas(motoristasData);
    setVeiculos(veiculoData);
    setLocais(localData);
    setLocaisDestino(localData);
    setloadingDados(false);
  };
  useEffect(() => {
    getData();
  }, []);

  const onChangeLocalOrigem = async (value) => {
    const localOrigemAux = JSON.parse(value);
    setLocalOrigem(localOrigemAux);
  };

  const onChangeLocalDestino = async (value) => {
    const localDestinoAux = JSON.parse(value);
    setLocalDestino(localDestinoAux);
  };

  const finaliza = async (id) => {
    try {
      setLoadingFinalizar(true);
      await finalizarViagem(id);
      setLoadingFinalizar(false);
    } catch (error) {
      setError(error.error);
      setLoadingFinalizar(false);
    }
  };
  return (
    <>
      {error && (
        <>
          <Alert message={error} type="error" />
          <br />
        </>
      )}
      <Form
        form={form}
        onChange={onEdit}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
        initialValues={initialValues}
      >
        <Row>
          <Col span={12}>
            <Card title="Dados básicos" style={{ ...cardStyle }}>
              <Row gutter={[8, 8]}>
                <Col span={8}>
                  <FormItemSelect
                    viewMode={viewMode}
                    name="prioridade"
                    label="Prioridade"
                    items={PRIORIDADE_FIELDS}
                    required
                    {...formItemLayout}
                  />
                </Col>
              </Row>
              <FormItemSelect
                viewMode={viewMode}
                label="Paciente"
                name="paciente"
                stringfyValue
                onSearch={onSearch}
                items={pacientes}
                itemsLabel={["pessoa_fisica", "nome"]}
                required
                {...formItemLayout}
              />
              <FormItemSelect
                viewMode={viewMode}
                label="Motorista"
                name="motorista"
                stringfyValue
                items={motoristas}
                itemsLabel={["nome"]}
                {...formItemLayout}
              />
              <FormItemSelect
                viewMode={viewMode}
                label="Veiculo"
                name="veiculo"
                stringfyValue
                items={veiculos}
                itemsLabel={["descricao"]}
                {...formItemLayout}
              />
            </Card>
            <Card title="Infomações adicionais" style={{ ...cardStyle }}>
              <Row gutter={[8, 8]}>
                <Col span={8}>
                  <FormItemInput
                    label="Acompanhante 1"
                    name="acompanhante_1"
                    viewMode={viewMode}
                    {...formItemLayout}
                  />
                </Col>
                <Col span={8}>
                  <FormItemInput
                    label="Acompanhante 2"
                    name="acompanhante_2"
                    viewMode={viewMode}
                    {...formItemLayout}
                  />
                </Col>
                <Col span={8}>
                  <FormItemInput
                    label="Acompanhante 3"
                    name="acompanhante_3"
                    viewMode={viewMode}
                    {...formItemLayout}
                  />
                </Col>
                <Col span={8}>
                  <FormItemInput
                    label="Acompanhante 4"
                    name="acompanhante_4"
                    viewMode={viewMode}
                    {...formItemLayout}
                  />
                </Col>
                <Col span={8}>
                  <FormItemInput
                    label="Contato"
                    name="contato"
                    required
                    rules={[
                      {
                        max: 11,
                        message: "O campo deve ter no máximo 11 caracteres",
                      },
                    ]}
                    viewMode={viewMode}
                    {...formItemLayout}
                  />
                </Col>
                <Col span={8}>
                  <FormItemInput
                    label="Whatsapp"
                    name="whatsapp"
                    rules={[
                      {
                        max: 11,
                        message: "O campo deve ter no máximo 11 caracteres",
                      },
                    ]}
                    viewMode={viewMode}
                    {...formItemLayout}
                  />
                </Col>
                <Col span={24}></Col>
              </Row>
              <Form.Item
                name="motivo_agendamento"
                label="Motivo do agendamento"
                rules={[{ required: true, message: "O campo é obrigatório" }]}
                {...formItemLayout}
              >
                <Input.TextArea disabled={viewMode} />
              </Form.Item>

              <Form.Item
                name="observacao"
                label="Observações"
                {...formItemLayout}
              >
                <Input.TextArea disabled={viewMode} />
              </Form.Item>
            </Card>
          </Col>
          <Col span={12}>
            <Card title="Sobre a viagem" style={{ ...cardStyle }}>
              <Row gutter={[8, 8]}>
                <Col span={6}>
                  <FormItemSelect
                    viewMode={viewMode}
                    label="Local de embarque"
                    name="local_origem"
                    stringfyValue
                    required
                    items={locais}
                    onChangeSelect={onChangeLocalOrigem}
                    itemsLabel={["descricao"]}
                    {...formItemLayout}
                  />
                  <DetailLocalBox local={localOrigem} />
                </Col>
                <Col span={6}>
                  <FormItemSelect
                    viewMode={viewMode}
                    label="Local de desembarque"
                    name="local_destino"
                    stringfyValue
                    required
                    items={locaisDestino}
                    onChangeSelect={onChangeLocalDestino}
                    itemsLabel={["descricao"]}
                    {...formItemLayout}
                  />
                  <DetailLocalBox local={localDestino} />
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Data de saida"
                    name="data_saida"
                    {...formItemLayout}
                  >
                    <DatePicker
                      locale={locale}
                      style={{ width: "100%" }}
                      disabled={viewMode}
                      format="DD/MM/YYYY"
                      placeholder="Selecione a data"
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Horário de saida"
                    name="horario_saida"
                    {...formItemLayout}
                  >
                    <TimePicker
                      locale={locale}
                      style={{ width: "100%" }}
                      disabled={viewMode}
                      format="HH:mm"
                      placeholder="Selecione o horário"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[8, 8]}>
                <Col span={6}>
                  <Form.Item
                    label="Horário estimado de chegada"
                    name="horario_estimado_chegada"
                    {...formItemLayout}
                  >
                    <TimePicker
                      locale={locale}
                      style={{ width: "100%" }}
                      disabled={viewMode}
                      format="HH:mm"
                      placeholder="Selecione o horário"
                    />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    label="Horário da marcação"
                    name="horario_marcacao"
                    rules={[
                      { required: true, message: "O campo é obrigatório" },
                    ]}
                    {...formItemLayout}
                  >
                    <TimePicker
                      locale={locale}
                      style={{ width: "100%" }}
                      disabled={viewMode}
                      format="HH:mm"
                      placeholder="Selecione o horário da marcação"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        {!disabledButtons && (
          <SkeletonContainer loading={loadingDados}>
            <div style={{ marginLeft: "25px" }}>
              {!viewMode && (
                <Form.Item>
                  <Button loading={loading} type="primary" htmlType="submit">
                    Enviar
                  </Button>
                </Form.Item>
              )}

              {viewMode && isAprovable() && user?.type !== "CLINICA" && (
                <Form.Item>
                  <Button
                    loading={loadingFinalizar}
                    onClick={() => finaliza(initialValues.id)}
                    type="primary"
                  >
                    Finalizar
                  </Button>
                </Form.Item>
              )}
            </div>
          </SkeletonContainer>
        )}
      </Form>
    </>
  );
}
